const topFirstAnime = () => {
  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {


    const jsSecFirstAime = document.getElementById('jsSecFirstAime')
    const jsConceptTxt1 = jsSecFirstAime.querySelector('.jsConceptTxt1')
    const jsConceptTxt2 = jsSecFirstAime.querySelector('.jsConceptTxt2')


    jsSecFirstAime.style.height = `${window.innerHeight}px`

    setTimeout(() => {
      jsConceptTxt1.classList.add('act')
    }, 500);

    setTimeout(() => {
      jsConceptTxt2.classList.add('act')
    }, 1000);

    setTimeout(() => {
      jsConceptTxt1.classList.remove('act')
      jsConceptTxt1.classList.add('none')
      jsConceptTxt2.classList.remove('act')
      jsConceptTxt2.classList.add('none')
    }, 3400);


    setTimeout(() => {
      jsSecFirstAime.classList.add('none')
    }, 3500);



    const jsMainWrap = document.getElementById('jsMainWrap')
    const jsImgBox1 = jsMainWrap.querySelector('.jsImgBox1')
    const jsImgBox2 = jsMainWrap.querySelector('.jsImgBox2')

    setTimeout(() => {
      jsImgBox1.classList.add('act')
    }, 3500);
    setTimeout(() => {
      jsImgBox2.classList.add('act')
    }, 4300);


  }
}
export default topFirstAnime;